import { useContext } from 'react';
import { UnsavedFormContext } from '../components/UnsavedForm/UnsavedFormProvider';

const useUnsavedForm = () => {
  return useContext(UnsavedFormContext);
};

export default useUnsavedForm;
